"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sha256 = void 0;
var sha256_browser_1 = require("@aws-crypto/sha256-browser");
var util_1 = require("@aws-crypto/util");
var node_hash_1 = require("./node_hash");
var Sha256 = /** @class */ (function () {
    function Sha256(secret) {
        if (supportsCryptoModule()) {
            this.hash = new node_hash_1.NodeHash("sha256", secret);
        }
        else {
            this.hash = new sha256_browser_1.Sha256(secret);
        }
    }
    Sha256.prototype.update = function (data, encoding) {
        this.hash.update((0, util_1.convertToBuffer)(data));
    };
    Sha256.prototype.digest = function () {
        return this.hash.digest();
    };
    Sha256.prototype.reset = function () {
        this.hash.reset();
    };
    return Sha256;
}());
exports.Sha256 = Sha256;
function supportsCryptoModule() {
    try {
        return !!require("crypto").createHash;
    }
    catch (_a) {
        return false;
    }
}
//# sourceMappingURL=index.js.map